import Layout from "@/components/feature/Layout";
import CharactersHeader from "./components/CharactersHeader";
import CharacterGrid from "./components/CharacterGrid";

function Characters() {
  return (
    <Layout>
      <title>嘿咻嘿咻漫画角色设定 - 阿浩、小雨、嘿咻猫咪等角色档案</title>
      <meta
        name="description"
        content="嘿咻嘿咻漫画角色设定全档案：主角阿浩、青梅竹马小雨、导师老周与吉祥物嘿咻猫咪等角色的性格、定位、台词与隐藏设定一览。"
      />
      <meta
        name="keywords"
        content="嘿咻嘿咻漫画角色,嘿咻嘿咻漫画角色设定,阿浩,小雨,嘿咻猫咪"
      />
      <link rel="canonical" href="https://characterz2.github.io/characters" />

      <CharactersHeader />
      <CharacterGrid />
    </Layout>
  );
}

export default Characters;